// Product price restore + selling_plan helpers for subscription PDPs only.
// - OTP restores the *current* variant base price (not page-load cache)
// - Does not force selling plans on regular product pages
// - Only enables selling_plan when a plan id is present

(function () {
  function isSubscriptionPdp() {
    // Shopify Subscriptions app block, or product JSON that requires a plan
    if (document.querySelector('[class*="shopify_subscriptions"], [id^="tab_otp_"], [id^="selling_plan_"]')) {
      return true;
    }
    try {
      var el = document.querySelector("[data-js-product-json]");
      if (!el) return false;
      var product = JSON.parse(el.textContent || "{}");
      return !!(product && product.requires_selling_plan);
    } catch (e) {
      return false;
    }
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "";
    var fmt =
      (window.themeCore &&
        window.themeCore.objects &&
        window.themeCore.objects.shop &&
        window.themeCore.objects.shop.money_format) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    if (
      window.themeCore &&
      window.themeCore.utils &&
      typeof window.themeCore.utils.formatMoney === "function"
    ) {
      return window.themeCore.utils.formatMoney(cents, fmt);
    }

    var amount = (Number(cents) / 100).toFixed(2).replace(/\.00$/, "");
    return fmt
      .replace("{{amount}}", amount)
      .replace("{{amount_no_decimals}}", String(Math.round(Number(cents) / 100)));
  }

  function getProductJson() {
    var el = document.querySelector("[data-js-product-json]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function getCurrentVariantId() {
    var root = document.querySelector("[data-js-product-container]") || document;
    var input =
      root.querySelector('[name="id"]') ||
      document.querySelector('form[data-js-product-form] [name="id"]') ||
      document.querySelector('[name="id"]');
    if (!input || !input.value) return null;
    var id = parseInt(input.value, 10);
    return isNaN(id) ? null : id;
  }

  function findVariant(product, variantId) {
    if (!product) return null;
    if (variantId && product.variants && product.variants.length) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === variantId) return product.variants[i];
      }
    }
    return (
      product.selected_or_first_available_variant ||
      (product.variants && product.variants[0]) ||
      null
    );
  }

  function applyBaseVariantPrice(variant) {
    if (!variant || variant.price == null) return;

    var price = variant.price;
    var compare = variant.compare_at_price;
    var onSale = compare != null && compare > price;
    var moneyPrice = formatMoney(price);
    var moneyCompare = compare != null ? formatMoney(compare) : "";

    document.querySelectorAll("[data-product-price]").forEach(function (el) {
      el.innerHTML = moneyPrice;
      el.setAttribute("data-amount", String(price));
    });
    document.querySelectorAll("[data-price-old]").forEach(function (el) {
      el.innerHTML = moneyCompare;
      if (compare != null) el.setAttribute("data-amount", String(compare));
    });
    document.querySelectorAll(".js-price").forEach(function (el) {
      el.classList.toggle("price--on-sale", onSale);
    });
  }

  function restoreOtpPrice() {
    var product = getProductJson();
    var variant = findVariant(product, getCurrentVariantId());
    applyBaseVariantPrice(variant);
  }

  window.restorePrice = restoreOtpPrice;

  function syncSellingPlanField(sp) {
    if (!sp || sp.type === "radio" || sp.type === "checkbox") return;
    if (sp.value && String(sp.value).length) {
      sp.disabled = false;
      sp.removeAttribute("disabled");
    } else {
      sp.disabled = true;
    }
  }

  function bindSellingPlanField(sp) {
    if (!sp || sp._spBound) return;
    sp._spBound = true;

    var sync = function () {
      syncSellingPlanField(sp);
    };
    sp.addEventListener("change", sync);
    sp.addEventListener("input", sync);
    sync();

    var last = sp.value;
    sp._spPoll = setInterval(function () {
      if (!document.contains(sp)) {
        clearInterval(sp._spPoll);
        return;
      }
      if (sp.value !== last) {
        last = sp.value;
        sync();
      }
    }, 250);
  }

  function manageSellingPlans() {
    if (!isSubscriptionPdp()) return;
    document.querySelectorAll('[name="selling_plan"]').forEach(bindSellingPlanField);
  }

  function attachOtpListeners() {
    if (!isSubscriptionPdp()) return false;
    var otpInputs = document.querySelectorAll('[id^="tab_otp_"]');
    otpInputs.forEach(function (input) {
      if (input._otpBound) return;
      input._otpBound = true;
      input.addEventListener("change", function () {
        if (input.type === "radio" && !input.checked) return;
        document.querySelectorAll('input[name="selling_plan"]:not([type="radio"])').forEach(function (sp) {
          sp.value = "";
          syncSellingPlanField(sp);
        });
        restoreOtpPrice();
      });
    });
    return otpInputs.length > 0;
  }

  function attachPlanRadioListeners() {
    if (!isSubscriptionPdp()) return;
    document.querySelectorAll('input[type="radio"][name="selling_plan"]').forEach(function (radio) {
      if (radio._planBound) return;
      radio._planBound = true;
      radio.addEventListener("change", function () {
        if (!radio.checked) return;
        var formId = radio.getAttribute("form");
        var form =
          (formId && document.getElementById(formId)) ||
          radio.closest("form") ||
          document.querySelector("form[data-js-product-form]");
        if (!form) return;
        var hidden = form.querySelector('input[name="selling_plan"]:not([type="radio"])');
        if (!hidden) {
          hidden = document.createElement("input");
          hidden.type = "hidden";
          hidden.name = "selling_plan";
          form.appendChild(hidden);
        }
        hidden.value = radio.value || "";
        syncSellingPlanField(hidden);
      });
    });
  }

  function boot() {
    if (!document.querySelector("[data-js-product-container]")) return;
    manageSellingPlans();
    attachOtpListeners();
    attachPlanRadioListeners();

    if (!isSubscriptionPdp()) return;

    var observer = new MutationObserver(function () {
      manageSellingPlans();
      attachOtpListeners();
      attachPlanRadioListeners();
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
